import { AfterViewChecked, ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectionList } from '@angular/material/list';
import { MatTabGroup } from '@angular/material/tabs';
import { ToastrService } from 'ngx-toastr';
import { SubSink } from 'subsink2';
import { SerialNumberScanOptionalComponent } from './serial-number-scan-optional/serial-number-scan-optional.component';

export class SerialNumberOptionalObject {
  guid: any;
  sn_id: string;
  status: string;
  remarks: string;
}

@Component({
  selector: 'app-util-line-item-serial-number-optional',
  templateUrl: './serial-number-optional.component.html',
  styleUrls: ['./serial-number-optional.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SerialNumberOptionalComponent implements OnInit, OnDestroy, AfterViewChecked {

  @Input() serverDocType;
  @Input() selectedIndex$;
  @Input() editMode: boolean;
  @Input() txnType: string;
  @Input() postingStatus;
  @Input() serialNumberListing$;
  @Input() viewModelStore;
  @Input() ColumnViewActions;
  @Input() ColumnViewSelectors;
  
  @Input() draft$;
  @Input() invItem$;
  @Input() lineItem;
  @Input() hdr;
  protected subs = new SubSink();
  qty;
  
  selectAll = new FormControl(false);
  serialNumbers: any[] = [];
  
  gridApi;
  gridColumnApi;
  rowData = [];
  gridOptions = {
    
    defaultColDef: {
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        flex: 1,
        sortable: true,
        resizable: true
    },
    
  };
  columnsDefs = [
    {
      headerName: 'Serial Number', 
      field: 'sn_id',
      minWidth: 100,
      cellStyle: () => ({'text-align': 'left'}),
      headerCheckboxSelection: true,
      checkboxSelection: function(params) {
         return true;
      },
    },
    {
      headerName: 'Status', 
      field: 'status',
      minWidth: 80,
      cellStyle: () => ({'text-align': 'left'}),
    },
    {
      headerName: 'Remarks', 
      field: 'remarks',
      minWidth: 200,
      cellStyle: () => ({'text-align': 'left'}),
    }
  ]
  @ViewChild(MatTabGroup, {static: true}) matTab: MatTabGroup;
  @ViewChild(MatSelectionList, {static: true}) matList: MatSelectionList;
  @ViewChild(SerialNumberScanOptionalComponent) scan: SerialNumberScanOptionalComponent;
  itemGuid: string;
  hasInvalid = false;
  noDefaultValue = false;
  constructor( private toastr: ToastrService,) { 
  }

  ngOnInit() {
    this.subs.sink = this.serialNumberListing$.subscribe({
      next: (resolve: any) => {
        if(resolve && Array.isArray(resolve)){
          const invalid =resolve.filter(x=>x.status==='INVALID');
          this.hasInvalid =(invalid.length !==0)? true: false;
          this.serialNumbers = resolve
        }
      }
    });
    console.log('hdr',this.hdr)
    if(this.hdr && !this.hdr.guid_branch && !this.hdr.guid_comp && !this.hdr.guid_store){
      this.noDefaultValue = true;
    }else{
      this.noDefaultValue = false;
    }
    
  }

  getRowStyle(params) {
    if(params.data.status==='INVALID'){
      return {
        'color': 'red',
      }
    }
    return {};
  };

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.closeToolPanel();
  }


  ngAfterViewChecked() {
    this.matTab.realignInkBar();
  }

  onSelect(e) {
    this.selectAll.patchValue(false);
  }

  onSelectAll() {
    this.matList.selectedOptions.selected.length === this.matList.options.length ? this.matList.deselectAll() : this.matList.selectAll();
  }

  onRemove() {
    const selectedRows = this.gridApi.getSelectedRows();
    this.viewModelStore.dispatch(this.ColumnViewActions.processSerialNumberListing_RemoveSerialNumber({serialNumberListing: selectedRows}));
  }

  addSerialNumberFromScan(sn: string) {
    if(!this.checkExceedKO(1)){
      if (sn && sn.length >= 3 && !this.serialNumbers.some(s=>s.sn_id===sn)) {
        let snArr = []
        const snObj = new SerialNumberOptionalObject();
        snObj.sn_id = sn.trim();
        snObj.status = "VALIDATION_IN_PROGRESS";
        snArr.push(snObj);
        this.scan.invalid = false;
      } else {
        this.scan.invalid = true;
      }
    }
    
  }

  uploadSerialNumberList(list: any []){
    console.log('uploadSerialNumberList',list)
    if(!this.checkExceedKO(list.length)){
      this.viewModelStore.dispatch(this.ColumnViewActions.processSerialNumberListing_AddSerialNumber({serialNumberListing: list}))
      this.viewModelStore.dispatch(this.ColumnViewActions.processSerialNumberListing_CheckDuplicateOptional({serialNumberListing: list}))
    }
  }

  checkExceedKO(selectedQty: number){
    const KO = this.lineItem?(this.lineItem.item_property_json?.KO?true:false):false;
    const qty = this.lineItem?this.lineItem.quantity_base:0;
    const currentLength = this.serialNumbers.length + selectedQty;
    if(KO && currentLength>qty){
      this.toastr.error("Exceed knock off quantity", "Error", {
               tapToDismiss: true,
              progressBar: true,
               timeOut: 2000,
             });
      return true
    }else{
      return false
    }
   
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}